import {forEach, values, map, isNumber, isFinite, isEmpty, isNil} from 'lodash';
import {MONEY, UNITS, SALES, AVERAGE, LINES_OBJ_NAME} from './constants';

const selectLabel = (label) => {
  if (label.toUpperCase() === MONEY) {
    return 'money';
  } else if (label.toUpperCase() === UNITS) {
    return LINES_OBJ_NAME;
  } else if (label.toUpperCase() === SALES) {
    return 'sales';
  }
};

const verifiedLetter = (activeLetters, letter) => {
  return activeLetters.find((l) => l.letter === letter);
};

const getVerifiedLetters = (data, activeLetters) => {
  const temp = [];
  data.forEach((element) => {
    if (verifiedLetter(activeLetters, element.letter)) {
      temp.push({...element, 'letter': element.letter});
    }
  });
  return temp;
};

const removeSpaces = (str) => {
  return str.replace(/\s/g, '');
};

const filterByType = (data, type) => data.filter((element) => element.type === type);

export const roundNumber = (number) => {
  const vNumber = isNumber(number) ? number : 0;
  return Math.round(vNumber * 100) / 100;
};

const getRowByLetter = (data, label, filter) => {
  const result = {};
  forEach(data, (element) => {
    const filterCondition = filter === element.type;
    const index = `${element.letter}`;
    if (filterCondition || isEmpty(filter)) {
      const temp = {
        [`${element.type.slice(0, 1)}${element.number}`]: roundNumber(
          element[label]
        ),
      };
      result[index] = {...result[index], 'letter': element.letter, ...temp};
    }
  });

  return result;
};

export const sumQuantites = (data, field) => {
  return data.reduce((acu, current) => acu + current[field], 0) || 0;
};

export const numberWithCommas = (x) => {
  const roundNum = roundNumber(x);
  const parts = roundNum.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export const tranformCurrency = (numb) => {
  const formatter = new Intl.NumberFormat('en-US', {
    'style': 'currency',
    'currency': 'USD',
    'minimumFractionDigits': 2,
  });
  return formatter.format(numb);
};

export const sumValues = (data, type, filterParams = '') => {
  const result = {};
  forEach(data, (e) => {
    const filterCondition = e.type === filterParams;
    if (filterCondition || isEmpty(filterParams)) {
      const index = `${e.letter}`;
      if (type.toUpperCase() === MONEY) {
        result[index] = (result[index] || 0) + e.money;
      } else if (type.toUpperCase() === UNITS) {
        result[index] = (result[index] || 0) + e[LINES_OBJ_NAME];
      } else if (type.toUpperCase() === SALES) {
        result[index] = (result[index] || 0) + e.sales;
      }
    }
  });
  return result;
};

export const averageMoneyBySales = (data, salesSixMonths, filter) => {
  const moneyObj = sumValues(data, MONEY, filter);
  const sales = sumValues(salesSixMonths, SALES, filter);
  const result = {};
  forEach(moneyObj, (e, index) => {
    const value = !isNil(sales[index]) ? sales[index] : 0;
    if (value !== 0) {
      result[index] = roundNumber(e / value);
    }
  });
  return result;
};

export const avergageMoneyBySalesLetters = ({dataStock, dataSales, filterParam}, activeLetters) => {
  const moneyObj = getVerifiedLetters(dataStock, activeLetters, filterParam);
  const parseDataMoney = getRowByLetter(moneyObj, 'money', filterParam);
  const sales = getVerifiedLetters(dataSales, activeLetters, filterParam);
  const parseDataSales = getRowByLetter(sales, 'sales', filterParam);
  const result = {};
  forEach(parseDataMoney, (elements) => {
    const letter = removeSpaces(elements.letter);
    forEach(elements, (item, index) => {
      let temp = {};
      if (isNumber(item) && !isEmpty(parseDataSales[letter])) {
        const salesValue = parseDataSales[letter];
        const value = !isNil(salesValue[index]) ? salesValue[index] : 0;
        if (value !== 0) {
          temp = {[index]: roundNumber(item / value)};
          result[letter] = {...result[letter], letter, ...temp};
        }
      }
    });
  });
  return values(result);
};

export const parseAverageDataTotal = (moneyData, salesData, selectBtn) => {
  let moneyD = moneyData;
  let salesD = salesData;
  if (selectBtn === AVERAGE) {
    moneyD = filterByType(moneyData, 'REPUESTOS');
    salesD = filterByType(salesData, 'REPUESTOS');
  }
  const money = sumQuantites(moneyD, 'money');
  const sales = sumQuantites(salesD, 'sales');
  const resp = money / sales;
  return isNumber(resp) && isFinite(resp) ? resp : 0;
};

export const filterByletters = ({data, filterParam}, selected, activeLetters) => {
  const label = selectLabel(selected);
  const parseData = getVerifiedLetters(data, activeLetters);
  const result = getRowByLetter(parseData, label, filterParam);
  return values(result);
};

export const transformDataChart = (data) => {
  return map(data, (e, idx) => {
    return ({
      'letter': idx,
      'Total': roundNumber(e),
      'label': tranformCurrency(roundNumber(e)),
      'quantity': numberWithCommas(roundNumber(e)),
    });
  });
};
